import script from "./ImageGalleryModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageGalleryModal.vue?vue&type=script&setup=true&lang=js"

import "./ImageGalleryModal.vue?vue&type=style&index=0&id=3e452328&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e452328"]])

export default __exports__